import { Command } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';

import { PopperProps } from '../../types';
import { insertNode, selectionType } from '../../utils';
import { EMOJI_PLUGIN_KEY } from './consts';

const calculateOffset = (elementPos: DOMRect, domNodeRect: DOMRect) => {
  return [elementPos.left - domNodeRect.left, domNodeRect.top - elementPos.top];
};

const calculateTransformOrigin = (elementPos: DOMRect, maxHeight: number) => {
  if (elementPos.top < maxHeight) {
    return 'bottom-start';
  } else {
    return 'top-start';
  }
};

export const closeDialog: Command = (state, dispatch) => {
  if (dispatch) {
    dispatch(state.tr.setMeta(EMOJI_PLUGIN_KEY, { open: false }));

    return true;
  }

  return false;
};

interface GetPopperPropsParams {
  editorView: EditorView;
  maxHeight: number;
}

export const getPopperProps = ({
  editorView,
  maxHeight,
}: GetPopperPropsParams): Partial<PopperProps> => {
  const cursorPos = editorView.state.selection.$to.pos;
  const coordsPos = editorView.coordsAtPos(cursorPos) as DOMRect;
  const domAtPos = editorView.domAtPos(cursorPos);
  const domNode = domAtPos.node.nodeName === '#text' ? domAtPos.node.parentElement : domAtPos.node;
  // @ts-ignore
  const domNodeRect = domNode.getBoundingClientRect();

  return {
    anchorEl: domNode as PopperProps['anchorEl'],
    placement: calculateTransformOrigin(coordsPos, maxHeight),
    popperOptions: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: calculateOffset(coordsPos, domNodeRect),
          },
        },
        {
          name: 'flip',
          enabled: false,
        },
      ],
    },
  };
};

export const insertEmoji = (
  editorView: EditorView,
  emojiString: string,
  from: number,
  to?: number,
) => {
  insertNode(editorView, selectionType.TEXT, emojiString, from, to);
  editorView.dispatch(
    editorView.state.tr.addMark(from, from + 2, editorView.state.schema.marks.emoji.create()),
  );
};
